import { render } from "./startup-user-component.vue?vue&type=template&id=6a073f32&ts=true"
import script from "./startup-user-component.vue?vue&type=script&lang=ts"
export * from "./startup-user-component.vue?vue&type=script&lang=ts"

import "./startup-user-component.vue?vue&type=style&index=0&id=6a073f32&lang=scss"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__